import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';
import afterEach from './after-each';
import appConfig from '../config';

Vue.use(VueRouter);

// fix NavigationDuplicated 错误
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

const router = new VueRouter({
  mode: 'history',
  base: appConfig.publicPath,
  routes,
});

afterEach(router);

// 获取权限，路由守护，权限拦截，设置PV埋点
router.beforeEach((to, from, next) => {
  next();
});

export { routes };

export default router;
